<template>
  <div
    class="list-item"
    :class="getItemClass(assetModule)">
    <div class="list-item__name-panel">
      <div
        class="list-item__status">
        <module-status-badge
          class="list-item__status-badge"
          :value="assetModule.status"
        />
      </div>
      <label class="list-item__name">
        {{ assetModule.name }}
      </label>
    </div>
    <div class="list-item__reading-panel">
      <div
        class="list-item__self-diagnosis"
        v-if="shouldShowSelfDiagnosis">
        <div
          class="list-item__self-diagnosis-badge">
          <b-badge
            variant="dark"
            pill>
            <i
              aria-hidden="true"
              class="fas fa-exclamation-circle"
            />
            {{ $t('enums.module-self-diagnosis-status.with-self-diagnoses-activated') }}
          </b-badge>
        </div>
      </div>
      <div
        v-else
        class="list-item__last-reading">
        <label
          class="list-item__last-reading-label">
          {{ $t('fields.digital-network.last-reading') }}
        </label>
        <date-time-label
          :value="assetModule.lastReadingTime"/>
      </div>
    </div>
  </div>
</template>

<script>
import digitalNetworkItemMixin from '@/domain/mixins/generalPanel/mySigma/digitalNetworkItemMixin';
import ModuleStatusBadge from '../../networkStatus/ModuleStatusBadge';

export default {
  components: {
    ModuleStatusBadge,
  },
  mixins: [digitalNetworkItemMixin],
  methods: {
    getItemClass(assetModule) {
      return {
        [`list-item__status_${assetModule.status}`]: true,
      };
    },
  },
};
</script>

<style lang="sass" scoped>
  @import ~@/styles/components/badge-default-colors.sass
  @import "src/styles/defaults/mobile-first"

  .list-item
    padding: .5em
    display: flex
    border-top: 1px solid var(--color-gray-medium-light)
    &:last-child
      border-bottom: 1px solid var(--color-gray-medium-light)
    &__name
      margin-top: .75em
    &__status
      &_active
        color: $status-active
      &_inactive
        color: $status-inactive
        background-color: rgba($status-inactive, .05)
        .list-item
          &__last-reading
            color: $status-inactive
      &-disabled
        color: $status-disabled
      &-establishing-communication
        color: $status-establishing-communication
      &-under-maintenance
        color: $status-under-maintenance
      &_indeterminate
        color: $status-indeterminate
      &_partial-communication
        color: $status-partial-communication
    &__last-reading-label
      display: block
      margin-bottom: 0
    &__last-reading,
    &__self-diagnosis
      color: var(--font-color-primary)
    &__self-diagnosis-input
      display: inline-flex
      max-width: 200px
    &__self-diagnosis-icon
      color: var(--font-color-primary)
    +media-max-md()
      text-align: center
      flex-direction: column
    +media-min-lg()
      flex-direction: row
      align-items: center
      padding-top: .75em
      padding-bottom: .75em
      .list-item
        &__name-panel
          flex: 1
        &__name
          margin-bottom: 0
        &__self-diagnosis,
        &__last-reading
          width: 200px
          text-align: center
</style>
